import MyDrive from '../views/pages/drive/MyDrive';
import SharedWithMe from '../views/pages/drive/SharedWithMe';
import routeVisibleForRole from '../util/routeVisibleForRole';

const driveRoutes = [
  {
    collapse: true,
    state: 'driveCollapse',
    name: 'Documents',
    icon: 'fa fa-folder',
    invisible: !routeVisibleForRole(['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_TENANT_ADMIN', 'ROLE_LEVEL1', 'ROLE_LEVEL2', 'ROLE_LEVEL3']),
    views: [
      {
        path: '/drive/my-drive/:uniqueId',
        name: 'My Drive',
        icon: ' ',
        component: MyDrive,
        layout: '/crm',
        invisible: true
      },
      {
        path: '/drive/my-drive',
        name: 'My Drive',
        icon: ' ',
        component: MyDrive,
        layout: '/crm',
        invisible: false
      },
      {
        path: '/drive/shared/:uniqueId/folder/:folderId',
        name: 'Shared with me',
        icon: ' ',
        component: SharedWithMe,
        layout: '/crm',
        invisible: true
      },
      {
        path: '/drive/shared/:uniqueId',
        name: 'Shared with me',
        icon: ' ',
        component: SharedWithMe,
        layout: '/crm',
        invisible: true
      },
      {
        path: '/drive/shared',
        name: 'Shared with me',
        icon: ' ',
        component: SharedWithMe,
        layout: '/crm',
        invisible: false
      },

    ]
  }
];

export default driveRoutes; 